export const convertDateString = (dateString) => {
  if (!dateString) return "";

  // 1. Split to avoid timezone shifting
  const [year, month, day] = dateString.split("-").map(Number);

  // 2. Create Date object (Month is 0-indexed in JS)
  const dateObject = new Date(year, month - 1, day);

  // 3. Format components
  const dayStr = day?.toString().padStart(2, "0");
  const monthStr = dateObject.toLocaleString("en-US", { month: "short" });
  const yearStr = year;

  // 4. Return as a plain string
  return `${dayStr}-${monthStr}-${yearStr}`;
};
